import { useInvoicesStats } from "@/Shared/Invoices/Hooks/useInvoicesStats";
import { NavBarInvoiceWarningBadge } from "@/Features/Nav/CustomComponents/Internal/NavBarInvoiceWarningBadge";

export function NavBarInvoiceWarning() {
  const { invoicesStats } = useInvoicesStats();

  if (invoicesStats === undefined) {
    return <></>;
  }

  return (
    <NavBarInvoiceWarningBadge
      invoiceWarningState={invoicesStats.invoiceWarningState}
    />
  );
}
